module.exports = __webpack_public_path__ + "media/images/favicon-7017ca63.png";